import { reducer as userConfigurationReducer } from '@noths/polaris-client-user-configuration';
import { reducer as favouritesReducer } from '@noths/polaris-client-user-favourites';
import { combineReducers } from '@reduxjs/toolkit';
import { routerReducer } from 'connected-next-router';

import { reducer as filterReducer } from 'src/components/organisms/Filter';
import { reducer as filterMenuReducer } from 'src/components/organisms/FilterMenu';
import { reducer as navigationReducer } from './navigation';
import { reducer as productReducer } from './products';

export const combinedReducer = combineReducers({
  filter: filterReducer,
  filterMenu: filterMenuReducer,
  navigation: navigationReducer,
  products: productReducer,
  router: routerReducer,
  userConfiguration: userConfigurationReducer,
  favourites: favouritesReducer,
});

export type ReduxApplicationState = ReturnType<typeof combinedReducer>;
